import { render, staticRenderFns } from "./PurchaseOrderFilters.vue?vue&type=template&id=6ddf2300&scoped=true"
import script from "./PurchaseOrderFilters.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderFilters.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderFilters.vue?vue&type=style&index=0&id=6ddf2300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf2300",
  null
  
)

export default component.exports